import { Link } from 'react-router-dom'
import styles from './logo.module.css'

export function Logo() {
  return (
    <Link to="/" className={styles.logo} aria-label="Go to home page">
      Trackly
    </Link>
  )
}